export default "__VITE_ASSET__BiD2k$8s__"